import { useEffect } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import { Link, Typography } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';

// components
import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import { usePathname } from 'src/routes/hooks';
import { NavSectionVertical } from 'src/components/nav-section';
//
import { Constants } from 'src/constants';
import { Colors } from 'src/theme/palette';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
  customLogoUrl?: string;
};

export default function NavVertical({ openNav, onCloseNav, customLogoUrl }: Props) {
  const pathname = usePathname();

  const lgUp = useResponsive('up', 'lg');

  const navData = useNavData();

  useEffect(() => {
    if (!lgUp && openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lgUp, pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1000,
        },
      }}
    >
      <Logo sx={{ mt: 2, mb: 1, pl: 3 }} customLogoUrl={customLogoUrl} black iconOnly={lgUp && !openNav} />


      <NavSectionVertical
        data={navData}
        collapsedDisplay={lgUp && !openNav}
      />
      {!(lgUp && !openNav) && <>
        <Box paddingLeft={4}>
          <div>
            <Link href="mailto:support@countingtrucks.com" sx={{ color: 'text.disabled', fontSize: 13, textDecoration: "none" }}>
              support@countingtrucks.com
            </Link>
          </div>
          <div>
            <Typography variant="body2" noWrap sx={{ color: 'text.disabled', fontSize: 13 }}>
              +1 (650) 549-9010
            </Typography>
          </div>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          sx={{
            px: 2,
            py: 1,
            textAlign: 'center',
          }}
        >
          <Stack alignItems="center">
            <Stack spacing={0.5} sx={{ mt: 1.5, mb: 0.1 }}>
              <Typography variant="body2" noWrap sx={{ color: 'text.disabled', fontSize: 10 }}>
                © 2024-2026, {Constants.PRODUCT_NAME}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </>}
    </Scrollbar>
  );

  return (
    <Box
      display={!lgUp && !openNav ? "none" : undefined}
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: openNav ? NAV.W_VERTICAL : NAV.W_VERTICAL_NOT_OPEN },
      }}
    >

      {/* <NavToggleButton /> */}

      {lgUp ? (
        <Stack
          sx={{
            background: Colors.topbarSidebar,
            height: 1,
            position: 'fixed',
            width: { xs: NAV.W_VERTICAL, lg: openNav ? NAV.W_VERTICAL : NAV.W_VERTICAL_NOT_OPEN },
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              background: `${Colors.topbarSidebar} !important`,
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
